/* This file was generated automatically. Do not edit manually. */

export enum RoutedItemType {
    CityTax = 'CityTax',
    SpaceOrder = 'SpaceOrder',
    AllProducts = 'AllProducts',
    Deposits = 'Deposits',
    AdditionalExpenses = 'AdditionalExpenses',
    AllCustomItems = 'AllCustomItems',
}
